import api from '../api';

export const fetchNewQuestions = async (lastFetchDate) => {
    try {
        const params = lastFetchDate ? { lastFetchDate } : {};
        const response = await api.get('/api/getQuestions', { params });
        return response.data;
    } catch (error) {
        console.error('Error fetching new questions:', error);
        return [];
    }
};
